import InsiderLoading from '/asset/loading_animation.webm';
interface AlertsProps {
  message?: string;
}
export default function Alerts({ message }: AlertsProps) {
  return (
    <div
      className="fixed inset-0 px-[50px] bg-white 
    z-50 flex items-center justify-center bg-white
    "
    >
      <div className="bg-white rounded-2xl p-6 w-full max-w-xl">
        <video
          autoPlay
          muted
          playsInline
          loop
          className="w-[100px] h-[100px] m-auto mb-[30px]"
          aria-hidden="true"
        >
          <source src={InsiderLoading} type="video/webm" />
        </video>
        <div className="text-[16px] max-w-[400px] m-auto font-[500] text-center text-primary-700">
          {message}
        </div>
      </div>
    </div>
  );
}
